import { instance } from "./index";

const API_PATH = "/notice";
const noticeManager = {
    getNotice: () => {
        return instance.get(`${API_PATH}/read`);
    },
    getNoticeDetail: (id) => {
        return instance.get(`${API_PATH}/read/detail/${id}`);
    },
    createNotice: (data) => {
        return instance.post(`${API_PATH}/write`, data);
    },
    updateNotice: (data) => {
        return instance.put(`${API_PATH}/update`, data);
    },
    deleteNotice: (id) => {
        return instance.delete(`${API_PATH}/delete?id=${id}`);
    },
    uploadImage: (formData) => {
        return instance.post(`${API_PATH}/upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    updateImage: (formData) => {
        return instance.put(`${API_PATH}/image/update`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    readConfirm: (data) => {
        return instance.post(`${API_PATH}/read/confirm`, data);
    },
};

export default noticeManager;
